import React, { useContext, useEffect, useState } from 'react';

import { TEMPTED_BACKEND } from '../../constants/apiUrls/apiUrls';
import { UserContext } from '../../context';
import callApi from '../../utils/callApi';
import './TrendingPage.css';
import PrivateContent from '../TrendingSection/PrivateContent';
import LoadMore from '../generalComponents/LoadMore';


const TrendingPage = () => {
  const [shopItem, setShopItem] = useState();
  const [newAddition, setNewAddition] = useState();
  const user = useContext(UserContext);
  const [itemsNumber, setItemsNumber] = useState(5);

  const getTopSpot = async() => {
    callApi('https://shop.nakednews.com/index.php/wp-json/wc/store/products', 'get', {}, {}, {}, false, false).then((res) => {
      setShopItem(res.data.slice(0, 3));
    });
  };

  const getBottomSpot = async() => {
    callApi(`${TEMPTED_BACKEND}/rest/v1/anchor/videos-galleries?offset=0&limit=${itemsNumber}`, 'get', {}).then((res) => {
      setNewAddition(res.data.itemList);
    });
  };

  const checkIfSubscribed = (anchorInfo) => !!(user.authenticated && user.user.account.anchorSubscriptions.length && user.user.account.anchorSubscriptions.find((anchor) => anchor.anchorName === anchorInfo.anchorName));

  const loadMore = () => {
    setItemsNumber(itemsNumber + 6);
  };

  const getAnchorShortUrl = (anchorInfo) => `naked-news-anchor-${anchorInfo.anchorName.toLowerCase().split(' ').join('-')}-a${anchorInfo.anchorId}`;

  useEffect(() => {
    getTopSpot();
    getBottomSpot();
  }, [itemsNumber]);

  return (
    <div className="trending-page-content">
      <div className="trending-page">
        <h1 className="trending-page-title">Trending</h1>
        <div className="trending-page-container">
          <div className="trending-page-content-grid">
            {shopItem && shopItem.map((item) => (<div key={item.id} className="trending-page-item-container">
              <a href={item.permalink} rel="noreferrer" target="_blank">
                <div className="trending-page-item-image">
                  <img alt={item.name} src={item.images[0].src} />
                </div>
                <div className="trending-page-item-caption">
                  <p dangerouslySetInnerHTML={{ __html: item.name }} className="trending-page-item-name" />
                  <div className="trending-page-item-description">
                    <p>{item.short_description && item.short_description.replace(/(<([^>]+)>)/ig, '').slice(0, 60).concat('...')}</p>
                  </div>
                </div>
              </a>
            </div>
            ))}

            {newAddition && newAddition.map((newAdd) => (<div key={newAdd.date} className="trending-page-item-container">
              <PrivateContent anchorId={newAdd.anchorId} anchorShortUrl={getAnchorShortUrl(newAdd)} galleriesAndVideos={Array(newAdd)} subscribed={checkIfSubscribed(newAdd)} user={user} videoClass={true} />
              <div className="trending-page-item-caption">
                <p className="trending-page-item-name">{newAdd.title}</p>
                {newAdd.description && <div className="trending-page-item-description">
                  <p>{newAdd.description.replace(/(<([^>]+)>)/ig, '').slice(0, 80).concat('...') }</p>
                </div>}
              </div>
            </div>))}
          </div>
        </div>
        <div className="loader">
          <LoadMore isLoading={false} loadMore={loadMore} />
        </div>
      </div>
    </div>
  );
};

export default TrendingPage;
